// import { APPLICATION_VERSION, ENVIRONMENT } from 'config';
// import * as healthApi from 'api/health-api';
import * as logger from 'logger';
import { Dispatch, Middleware, MiddlewareAPI } from 'redux';
import { 
  GET_CONNECTION_STATUS,
  GET_OFFLINE_MODE_SIMULATION,
  SET_OFFLINE_MODE_SIMULATION, 
  SetConnectionStatusAction,
  SetOfflineModeSimulationAction } from './actions';
import { syncData } from 'service-worker/data-syncs/data-sync';
import * as connectionStatusService from 'services/connection-status-service';
import { ConnectionStatusState } from './state';
import { RefreshTokenAction } from 'pages/login/actions';

const actualFetch = window.fetch;

const ConnectionStatusMiddleware: Middleware = store => next => async action => {

  try {
    switch (action.type) {

      case GET_CONNECTION_STATUS:
        await connectionStatus(store, next);
        break;

      case GET_OFFLINE_MODE_SIMULATION:
        await getOfflineModeSimulation(store);
        break;

      case SET_OFFLINE_MODE_SIMULATION:
        await setOfflineModeSimulation(next, action);
        break;

      default:
        break;
    }

    next(JSON.parse(JSON.stringify(action)));
  }
  catch (e) {
    const error = e as Error;
    logger.error(error, 'ConnectionStatusMiddleware');
  }
};

async function connectionStatus(store: MiddlewareAPI, next: Dispatch): Promise<void> {
  const connectionStatusState = store.getState().connectionStatus as ConnectionStatusState;
  const previousConnectionStatus = connectionStatusState.isConnected;
  let isConnected = !connectionStatusState.isSimulatingOfflineMode;

  // try {
  //   const response = await healthApi.healthCheck();
  //   if (response.appVersion !== APPLICATION_VERSION && ENVIRONMENT === 'RELEASE') {
  //     // force a refresh so the UI is updated to the latest
  //     forceRefresh();
  //  }
  // }
  // catch {
  //   isConnected = false;
  // }

  // set the connection status
  await setStatus(isConnected, next);

  // if coming from offline to online
  if (isConnected === true && previousConnectionStatus === false) {
    store.dispatch(new RefreshTokenAction);
    syncData();
  }
}

async function getOfflineModeSimulation(store: MiddlewareAPI) {
  const isSimulatingOfflineMode = await connectionStatusService.getOfflineModeSimulation() as boolean;
  store.dispatch(new SetOfflineModeSimulationAction(isSimulatingOfflineMode == null ? false : isSimulatingOfflineMode));
}

async function setOfflineModeSimulation(next: Dispatch, action: SetOfflineModeSimulationAction): Promise<void> {
  const shouldSimulateOfflineMode = action.shouldSimulate;

  // intercept fetch requests if simulating offline
  setFetch(shouldSimulateOfflineMode);

  // set offline simulation
  await connectionStatusService.setOfflineModeSimulation(shouldSimulateOfflineMode);

  // set connection status to false if simulating
  if (shouldSimulateOfflineMode === true) {
    await setStatus(false, next);
  }
}

async function setStatus(isConnected: boolean, next: Dispatch) {
  await connectionStatusService.setStatus(isConnected);
  next(JSON.parse(JSON.stringify(new SetConnectionStatusAction(isConnected))));
}

function setFetch(shouldSimulateOfflineMode: boolean) {
  if (shouldSimulateOfflineMode === true) {
    // tslint:disable
    window.fetch = async function() : Promise<any> {
      return {
        status: 404,
        statusText: 'Simulating offline mode'
      };
    };
  } else {
    window.fetch = actualFetch;
  }
}

// function forceRefresh() {
//   const twoMinutes = 120000;
//  // use setTimeout in case we are in the scenario of API switched over from Staging to Prod slot
//   // but UI is still switching over from Staging to Prod slot
//   setTimeout(() => {
//    // reload the current page without browser cache
//    location.reload(true);
//   }, twoMinutes);
// }

export default ConnectionStatusMiddleware;


// WEBPACK FOOTER //
// ./src/components/connection-status/middleware.ts